module.exports = __webpack_public_path__ + "static/media/during-a-colonoscope-02@3x.755cfb2f.jpg";